var xhr = require('../utils/xhr');

module.exports = {
    loadContacts: function(callback) {
        xhr.simpleCall({
            func: 'contacts'
        }, function (res) {
            callback(res.data);
        });
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/contacts/service.js
 ** module id = 26
 ** module chunks = 0
 **/